import React from 'react';
import { SignInButton, SignUpButton } from '@clerk/clerk-react';
import './HelpPage.css';
import './LandingPage.css';

function Capability({ icon, title, badge, children }) {
  return (
    <div className="hp-wf-card">
      <div className="hp-wf-card-icon">{icon}</div>
      <h3 className="hp-wf-card-title">{title}</h3>
      {badge && <span className="hp-wf-badge">{badge}</span>}
      <p className="hp-wf-card-desc">{children}</p>
    </div>
  );
}

function Step({ n, icon, title, children }) {
  return (
    <div className="lp-step-card">
      <div className="lp-step-icon">{icon}</div>
      <div className="lp-step-num">{n}</div>
      <h3 className="lp-step-title">{title}</h3>
      <p className="lp-step-desc">{children}</p>
    </div>
  );
}

export default function LandingPage({ onViewHelp }) {
  return (
    <div className="hp-root">
      {/* ── Hero ── */}
      <div className="hp-hero">
        <div className="hp-hero-inner">
          <div className="hp-church-wordmark">Godstone Tabernacle</div>
          <h1 className="hp-hero-title">Sermon Studio</h1>
          <p className="hp-hero-sub">
            Turn a recorded sermon into a written transcript, and translate it
            so congregations in other languages can receive it too — built for
            our own media and translation team.
          </p>
          <div className="lp-hero-buttons">
            <SignInButton mode="modal">
              <button className="btn-primary btn-large">Sign In</button>
            </SignInButton>
            <SignUpButton mode="modal">
              <button className="btn-secondary btn-large">Create Account</button>
            </SignUpButton>
          </div>
        </div>
      </div>

      {/* ── What it does ── */}
      <div className="hp-pillars-wrap">
        <div className="hp-pillars">
          <Capability icon="🎙️" title="Transcription" badge="Audio · Video">
            Upload a sermon recording and get back a complete, speaker-marked
            transcript you can play back line by line and correct in place.
          </Capability>
          <Capability icon="🌍" title="Translation" badge="20+ Languages">
            Translate sermon notes and outlines into over 20 languages.
          </Capability>
          <Capability icon="📚" title="Glossary" badge="Auto-applied">
            Teach the system pastor names, ministry terms, and scripture
            shorthand once — it corrects them automatically from then on.
          </Capability>
        </div>
      </div>

      {/* ── How it works ── */}
      <div className="lp-steps-wrap">
        <h2 className="lp-steps-title">How it works</h2>
        <div className="lp-steps">
          <Step n="1" icon="📤" title="Upload a recording">
            Drop in an audio or video file of a sermon, or a document to translate.
          </Step>
          <Step n="2" icon="👀" title="Review the result">
            Read through the transcript or translation, correct anything the
            system got wrong, and save.
          </Step>
          <Step n="3" icon="📨" title="Share it onward">
            Export as a Word document, plain text, or subtitle file — ready for
            interpreters or the church archive.
          </Step>
        </div>
        <button className="lp-more-link" onClick={onViewHelp}>
          See the full walkthrough →
        </button>
      </div>

      {/* ── Footer CTA ── */}
      <div className="lp-footer-cta">
        <p className="lp-footer-title">Ready to get started?</p>
        <p className="lp-footer-sub">Sign in with your Godstone Tabernacle account.</p>
        <SignInButton mode="modal">
          <button className="btn-primary btn-large">Sign In</button>
        </SignInButton>
      </div>
    </div>
  );
}
